export const FETCH_LAST_REVIEW = 'FETCH_LAST_REVIEW';
export const CREATE_REVIEW = 'CREATE_REVIEW';
